export const dayList = [
	{
		title: 'MON 10',
		revenueFrom: '750',
		revenueTo: '1200',
		dayInfo: {
			overBudgetPercentage: '12%',
			currentAmount: '$1,320.00',
			limitAmount: '$1,200.00',
			dayInfoShifts: [
				{
					position: 'Assistant Manager',
					current: 2,
					total: 2,
				},
				{
					position: 'Server',
					current: 0,
					total: 1,
				},
			],
		},
	},
	{
		title: 'TUE 11',
		revenueFrom: '750',
		revenueTo: '1200',
		dayInfo: {
			overBudgetPercentage: '',
			currentAmount: '$1,100.00',
			limitAmount: '$1,200.00',
			dayInfoShifts: [
				{
					position: 'Assistant Manager',
					current: 2,
					total: 2,
				},
				{
					position: 'Server',
					current: 1,
					total: 1,
				},
			],
		},
	},
	{
		title: 'WED 12',
		revenueFrom: '750',
		revenueTo: '1200',
		dayInfo: {
			overBudgetPercentage: '',
			currentAmount: '$990.00',
			limitAmount: '$1,200.00',
			dayInfoShifts: [
				{
					position: 'Assistant Manager',
					current: 2,
					total: 2,
				},
				{
					position: 'Server',
					current: 1,
					total: 1,
				},
			],
		},
	},
	{
		title: 'THU 13',
		revenueFrom: '750',
		revenueTo: '1200',
		dayInfo: {
			overBudgetPercentage: '',
			currentAmount: '$1,400.00',
			limitAmount: '$1,200.00',
			dayInfoShifts: [
				{
					position: 'Assistant Manager',
					current: 2,
					total: 2,
				},
				{
					position: 'Server',
					current: 1,
					total: 1,
				},
			],
		},
	},
	{
		title: 'FRI 14',
		revenueFrom: '750',
		revenueTo: '1200',
		dayInfo: {
			overBudgetPercentage: '',
			currentAmount: '$1,000.00',
			limitAmount: '$1,200.00',
			dayInfoShifts: [
				{
					position: 'Assistant Manager',
					current: 2,
					total: 2,
				},
				{
					position: 'Server',
					current: 0,
					total: 1,
				},
			],
		},
	},
	{
		title: 'SAT 15',
		revenueFrom: '750',
		revenueTo: '1200',
		dayInfo: {
			overBudgetPercentage: '',
			currentAmount: '$1,000.00',
			limitAmount: '$1,200.00',
			dayInfoShifts: [
				{
					position: 'Assistant Manager',
					current: 2,
					total: 2,
				},
				{
					position: 'Server',
					current: 0,
					total: 1,
				},
			],
		},
	},
	{
		title: 'SUN 16',
		revenueFrom: '750',
		revenueTo: '1200',
		dayInfo: {
			overBudgetPercentage: '',
			currentAmount: '$1,200.00',
			limitAmount: '$1,200.00',
			dayInfoShifts: [
				{
					position: 'Assistant Manager',
					current: 2,
					total: 2,
				},
				{
					position: 'Server',
					current: 1,
					total: 1,
				},
			],
		},
	},
];

export const tagList = [
	{
		id: 1,
		title: 'New Hire',
		color: '',
	},
	{
		id: 2,
		title: 'Requested',
		color: '#79abda',
	},
	{
		id: 3,
		title: 'Skilled',
		color: '#ce47a0',
	},
];

export const reasonList = [
	{
		id: 1,
		title: 'Works in Milwaukee store, lives 8mi from Chicago store',
		status: '#7cc230',
	},
	{
		id: 2,
		title: 'Prefers morning shifts Finishes training 3 days before',
		status: '#7cc230',
	},
	{
		id: 3,
		title: 'Will exceed weekly target Worked previous day until 11:30pm',
		status: '#ed6f70',
	},
];
export const overviewEmployeeList = [
	{
		id: 1,
		fullName: 'Mittie Welch',
		initials: 'MW',
		workedHours: '20',
		tagList: [1],
		shiftList: [1, 3, 5, 33, 9, 28, 36],
	},
	{
		id: 2,
		fullName: 'Inez Moran',
		initials: 'IM',
		workedHours: '23',
		tagList: [3],
		shiftList: [2, 24, 32, 8, 19, 11, 21],
	},
	{
		id: 3,
		fullName: 'John Doe',
		initials: 'JD',
		workedHours: '33',
		tagList: [2],
		shiftList: [23, 31, 17, 18, 19, 28, 29],
	},
	{
		id: 4,
		fullName: 'Chester Alexander',
		initials: 'CA',
		workedHours: '33',
		tagList: [1],
		shiftList: [23, 24, 25, 33, 34, 35, 36],
	},
	{
		id: 5,
		fullName: 'Joshua McKenzie',
		initials: 'JM',
		workedHours: '33',
		tagList: [3],
		shiftList: [2, 16, 17, 18, 27, 28, 36],
	},
];
export const employeeList = [
	{
		id: 1,
		fullName: 'Mittie Welch',
		initials: 'MW',
		workedHours: '20',
		statusColor: '#7cc230',
		tagList: [1],
		reasonList: [1, 2],
	},
	{
		id: 2,
		fullName: 'Inez Moran',
		initials: 'IM',
		workedHours: '20',
		statusColor: '#ed6f70',
		tagList: [1, 2],
		reasonList: [3],
	},
	{
		id: 3,
		fullName: 'John Doe',
		initials: 'JD',
		workedHours: '20',
		statusColor: '#ed6f70',
		tagList: [1, 3],
		reasonList: [3],
	},
	{
		id: 4,
		fullName: 'Chester Alexander',
		initials: 'CA',
		workedHours: '20',
		statusColor: '#ed6f70',
		tagList: [1, 3],
		reasonList: [3],
	},
	{
		id: 5,
		fullName: 'Joshua McKenzie',
		initials: 'JM',
		workedHours: '20',
		statusColor: '#ed6f70',
		tagList: [1, 3],
		reasonList: [3],
	},
];
export const jobPositions = [
	{
		id: 1,
		title: 'Assistant Manager',
		shiftList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
	},
	{
		id: 1,
		title: 'Server',
		shiftList: [15, 16, 17, 18, 19, 20, 21],
	},
];

export const shiftList = [
	{
		id: 1,
		date: 'Mar 30',
		shiftTimeString: '9am - 5pm (8h)',
		weather: '65ºF',
		employeeFullName: 'Randy Goodman',
		dateString: '2020-03-30',
		status: 'morningShift',
	},
	{
		id: 2,
		date: 'Mar 30',
		shiftTimeString: '5pm - 11pm (6h)',
		weather: '65ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-03-30',
		status: 'noonShift',
	},
	{
		id: 3,
		date: 'Mar 31',
		shiftTimeString: '9am - 5pm (8h)',

		event: 'Special Event 2 (3x)',
		weather: '65ºF',
		employeeFullName: 'Randy Goodman',
		dateString: '2020-03-31',
		status: 'morningShift',
	},
	{
		id: 4,
		date: 'Mar 31',
		shiftTimeString: '5pm - 11pm (6h)',

		event: 'Special Event 2 (3x)',
		weather: '65ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-03-31',
		status: 'noonShift',
	},
	{
		id: 5,
		date: 'Apr 01',
		shiftTimeString: '9am - 5pm (8h)',
		weather: '62ºF',
		employeeFullName: 'Randy Goodman',
		dateString: '2020-04-01',
		status: 'morningShift',
	},
	{
		id: 6,
		date: 'Apr 01',
		shiftTimeString: '5pm - 11pm (6h)',
		weather: '62ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-04-01',
		status: 'noonShift',
	},
	{
		id: 7,
		date: 'Apr 02',
		shiftTimeString: '9am - 5pm (8h)',

		event: 'Event1  (2x)',
		weather: '61ºF',
		employeeFullName: 'Randy Goodman',
		dateString: '2020-04-02',
		status: 'morningShift',
	},
	{
		id: 8,
		date: 'Apr 02',
		shiftTimeString: '5pm - 11pm (6h)',

		event: 'Event1  (2x)',
		weather: '61ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-04-02',
		status: 'noonShift',
	},
	{
		id: 9,
		date: 'Apr 03',
		shiftTimeString: '9am - 5pm (8h)',
		weather: '69ºF',
		employeeFullName: 'Randy Goodman',
		dateString: '2020-04-03',
		status: 'morningShift',
	},
	{
		id: 10,
		date: 'Apr 03',
		shiftTimeString: '5pm - 11pm (6h)',
		weather: '69ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-04-03',
		status: 'noonShift',
	},
	{
		id: 11,
		date: 'Apr 04',
		shiftTimeString: '9am - 5pm (8h)',

		event: 'Eurovision (4x)',
		weather: '55ºF',
		employeeFullName: 'Randy Goodman',
		dateString: '2020-04-04',
		status: 'morningShift',
	},
	{
		id: 12,
		date: 'Apr 04',
		shiftTimeString: '5pm - 11pm (6h)',

		event: 'Eurovision (4x)',
		weather: '62ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-04-04',
		status: 'noonShift',
	},
	{
		id: 13,
		date: 'Apr 05',
		shiftTimeString: '9am - 5pm (8h)',
		weather: '60ºF',
		employeeFullName: 'Randy Goodman',
		dateString: '2020-04-05',
		status: 'morningShift',
	},
	{
		id: 14,
		date: 'Apr 05',
		shiftTimeString: '5pm - 11pm (6h)',
		weather: '60ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-04-05',
		status: 'noonShift',
	},
	{
		id: 15,
		date: 'Mar 30',
		shiftTimeString: '5pm - 11pm (6h)',
		weather: '65ºF',
		dateString: '2020-03-30',
		status: 'unassigned',
	},
	{
		id: 16,
		date: 'Mar 31',
		shiftTimeString: '5pm - 11pm (6h)',
		event: 'Special Event 2 (3x)',
		weather: '65ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-03-31',
		status: 'noonShift',
	},
	{
		id: 17,
		date: 'Apr 01',
		shiftTimeString: '5pm - 11pm (6h)',
		weather: '62ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-04-01',
		status: 'noonShift',
	},
	{
		id: 18,
		date: 'Apr 02',
		shiftTimeString: '5pm - 11pm (6h)',
		event: 'Event1  (2x)',
		weather: '61ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-04-02',
		status: 'noonShift',
	},

	{
		id: 19,
		date: 'Apr 03',
		shiftTimeString: '5pm - 11pm (6h)',
		weather: '69ºF',
		status: 'unassigned',
		dateString: '2020-04-03',
	},
	{
		id: 20,
		date: 'Apr 04',
		shiftTimeString: '5pm - 11pm (6h)',
		weather: '62ºF',
		status: 'unassigned',
		dateString: '2020-04-04',
	},
	{
		id: 21,
		date: 'Apr 05',
		shiftTimeString: '5pm - 11pm (6h)',
		weather: '60ºF',
		employeeFullName: 'Jeff Miller',
		dateString: '2020-04-05',
		status: 'noonShift',
	},
	{
		id: 22,
		date: 'Mar 30',
		shiftTimeString: '5pm - 11pm (6h)',
		event: 'Eurovision (4x)',
		weather: '65ºF',
		employeeFullName: 'Jeff Miller',
		status: 'unassigned',
		dateString: '2020-04-03',
	},
	// !--dayOff
	{
		id: 23,
		dateString: '2020-03-30',
		status: 'dayOff',
	},
	{
		id: 24,
		dateString: '2020-03-31',
		status: 'dayOff',
	},
	{
		id: 25,
		dateString: '2020-04-01',
		status: 'dayOff',
	},
	{
		id: 26,
		dateString: '2020-04-02',
		status: 'dayOff',
	},
	{
		id: 27,
		dateString: '2020-04-03',
		status: 'dayOff',
	},
	{
		id: 28,
		dateString: '2020-04-04',
		status: 'dayOff',
	},
	{
		id: 29,
		dateString: '2020-04-05',
		status: 'dayOff',
	},
	// !--dayOff
	// !--unassigned
	{
		id: 30,
		dateString: '2020-03-30',
		status: 'unassigned',
	},
	{
		id: 31,
		dateString: '2020-03-31',
		status: 'unassigned',
	},
	{
		id: 32,
		dateString: '2020-04-01',
		status: 'unassigned',
	},
	{
		id: 33,
		dateString: '2020-04-02',
		status: 'unassigned',
	},
	{
		id: 34,
		dateString: '2020-04-03',
		status: 'unassigned',
	},
	{
		id: 35,
		dateString: '2020-04-04',
		status: 'unassigned',
	},
	{
		id: 36,
		dateString: '2020-04-05',
		status: 'unassigned',
	},
	// !--unassigned
];

export const storeList = [
	{ value: 1, text: 'Chicago' },
	{ value: 2, text: 'New York' },
	{ value: 3, text: 'Los Angeles' },
	{ value: 4, text: 'Washington' },
];
export const jobPositionList = [
	{ value: 1, text: 'Assistant Manager' },
	{ value: 2, text: 'Server' },
	{ value: 3, text: 'Chef' },
];

export function getJobPositionShiftList(momentRefference) {
	return jobPositions.map(jobPosition => {
		const test = jobPosition.shiftList.map(shiftId => {
			const shiftObject = shiftList.find(x => x.id === shiftId);
			return {
				...shiftObject,
				dateMoment: momentRefference(shiftObject.dateString),
			};
		});
		return {
			...jobPosition,
			shiftList: groupByArray(test, 'dateString'),
		};
	});
}

export function getEmployeeShiftList(momentRefference) {
	return overviewEmployeeList.map(employee => {
		const test = employee.shiftList.map(shiftId => {
			const shiftObject = shiftList.find(x => x.id === shiftId);
			return {
				...shiftObject,
				dateMoment: momentRefference(shiftObject.dateString),
			};
		});
		return {
			...employee,
			shiftList: groupByArray(test, 'dateString'),
		};
	});
}

export const filters = [
	{
		id: 'morningShift',
		title: 'Morning Shift',
		color: '#79abda',
	},
	{
		id: 'noonShift',
		title: 'Noon Shift',
		color: '#517fa8',
	},
	{
		id: 'nightShift',
		title: 'Night Shift',
		color: '#264c6d',
	},
	{
		id: 'onCall',
		title: 'On Call',
		color: '#daa479',
	},
	{
		id: 'unassigned',
		title: 'Unassigned',
		color: '#daa479',
	},
];
// not in use
export function getDaysArray(year, month) {
	const monthIndex = month - 1;
	const names = Object.freeze(['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']);
	const date = new Date(year, monthIndex, 1);
	const result = [];
	while (date.getMonth() == monthIndex) {
		result.push(`${names[date.getDay()]}` + ` ` + `${date.getDate()}`.padStart(2, '0'));
		date.setDate(date.getDate() + 1);
	}
	return result;
}

export function getWeekDays(momentRefference, { current = false, weekNumber }) {
	var currentDate = current ? momentRefference() : momentRefference().week(weekNumber);
	var weekStart = currentDate.clone().startOf('isoWeek');
	var weekEnd = currentDate.clone().endOf('isoWeek');
	const weekStartDate = weekStart;
	const weekEndDate = weekEnd;
	const monthString = currentDate.format('MMMM');
	const yearString = currentDate.format('YYYY');
	var days = [];

	for (var i = 0; i <= 6; i++) {
		days.push(
			momentRefference(weekStart)
				.add(i, 'days')
				.format('ddd Do'),
		);
	}
	return {
		days,
		weekStartDate,
		weekEndDate,
		monthString,
		yearString,
	};
}

export function groupBy(xs, key) {
	return xs.reduce(function(rv, x) {
		(rv[x[key]] = rv[x[key]] || []).push(x);
		return rv;
	}, {});
}
export function groupByArray(xs, key) {
	return xs.reduce(function(rv, x) {
		let v = key instanceof Function ? key(x) : x[key];
		let el = rv.find(r => r && r.key === v);
		if (el) {
			el.values.push(x);
		} else {
			rv.push({ key: v, values: [x] });
		}
		return rv;
	}, []);
}
export function shuffle(a) {
	for (let i = a.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[a[i], a[j]] = [a[j], a[i]];
	}
	return a;
}
export function isJson(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}
